import React from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Homepage from "./components/Main/Homepage";

function App() {
  return (
    <>
    <Header/>
    <Homepage/>
    <Footer/>
    </>
  );
}

export default App;
